import { Box, Button, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import Complaint from "../img/raiseicon.png"
import styleCss from "../Style/style"
import React, { useState } from "react";
import AttachFileIcon from '@mui/icons-material/AttachFile';

const Complaints = () => {
    const [value, setValue] = useState('');
    const [fileName, setFileName] = React.useState('');
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
        }
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ md: 6, xs:12}}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px',
                            overflow: 'hidden',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#030213',
                                    marginBottom: '25px',
                                }}>
                                    <img src={Complaint} style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                    Raise a Complaint
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={styleCss.CommonLabelName}>PNR Number (Optional)</Typography>
                                <TextField
                                    name=""
                                    variant="outlined"
                                    size="small"
                                    placeholder="Enter PNR if related to booking"
                                    fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "#f3f3f5",
                                            borderRadius: "8px",
                                            minHeight: "32px",
                                            padding: 0,
                                            "& input": {
                                                padding: "12px 10px",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                    fontSize: "14px",
                                                    color: "#717182",
                                                    opacity: 1,
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                },
                                            },
                                            "& fieldset": { borderColor: "#ddd" },
                                            "&:hover fieldset": { borderColor: "#bbb" },
                                            "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: "14px",
                                            color: "#364252",
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={styleCss.CommonLabelName}>Category</Typography>
                                <FormControl fullWidth size="small">
                                    <Select
                                        displayEmpty
                                        defaultValue=""
                                        fullWidth
                                        sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            fontWeight: 'normal',
                                            color: '#030213',
                                            backgroundColor: '#f9fafb',
                                            borderRadius: '8px',
                                            height: '45px',
                                            '& .MuiSelect-select': {
                                                padding: '12px 14px',
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '14px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#dedede',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#bdbdbd',
                                            },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#0e182b',
                                            },
                                        }}
                                    >
                                        <MenuItem disabled value="placeholder">
                                            <span style={{ color: '#717182', fontFamily: '"Segoe UI", sans-serif', fontSize: '14px', }}>Select complaint category</span>
                                        </MenuItem>
                                        <MenuItem value={10}>Option 1</MenuItem>
                                        <MenuItem value={20}>Option 2</MenuItem>
                                        <MenuItem value={30}>Option 3</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={styleCss.CommonLabelName}>Subject</Typography>
                                <TextField
                                    name=""
                                    variant="outlined"
                                    size="small"
                                    placeholder="Brief description of the issue"
                                    fullWidth
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            backgroundColor: "#f3f3f5",
                                            borderRadius: "8px",
                                            minHeight: "32px",
                                            padding: 0,
                                            "& input": {
                                                padding: "12px 10px",
                                                fontSize: "14px",
                                                "&::placeholder": {
                                                    fontSize: "14px",
                                                    color: "#717182",
                                                    opacity: 1,
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                },
                                            },
                                            "& fieldset": { borderColor: "#ddd" },
                                            "&:hover fieldset": { borderColor: "#bbb" },
                                            "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: "14px",
                                            color: "#364252",
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={styleCss.CommonLabelName}>Detailed Description</Typography>
                                <TextField
                                    multiline
                                    rows={3}
                                    placeholder="Detailed Description"
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '14px',
                                        fontWeight: 'normal',
                                        color: '#030213',
                                        backgroundColor: '#f9fafb',
                                        borderRadius: '8px',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#dedede',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#bdbdbd',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'transparent',
                                            },
                                        },
                                        '& .MuiInputBase-input': {

                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            color: '#030213',
                                        },
                                        '& .MuiInputBase-input::placeholder': {
                                            color: '#717182',
                                            opacity: 1,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Typography sx={styleCss.CommonLabelName}>Attached Files (Optional)</Typography>
                                <TextField
                                    fullWidth
                                    placeholder="Attach a file"
                                    value={fileName}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    component="label"
                                                    sx={{
                                                        padding: 0,
                                                    }}
                                                >
                                                    <AttachFileIcon sx={{ color: '#717182' }} />
                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={handleFileChange}
                                                    />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '14px',
                                        fontWeight: 'normal',
                                        color: '#030213',
                                        backgroundColor: '#f9fafb',
                                        borderRadius: '8px',
                                        height: '45px',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#dedede',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#bdbdbd',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#0e182b',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '12px 14px',
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            color: '#030213',
                                        },
                                        '& .MuiInputBase-input::placeholder': {
                                            color: '#717182',
                                            opacity: 1,
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Button variant="contained" sx={{
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 100px 0 rgba(0, 0, 0, 0.08)',
                                    backgroundColor: '#ff5714',
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '15px',
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    color: '#fff',
                                    width: '100%',
                                    display: 'block',
                                }}>Login</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12}}>
                    <Box
                        sx={{
                            bgcolor: " #fff",
                            borderRadius: "30px",
                            display: "block",
                            padding: '20px 20px 102px',
                            marginBottom: '30px',
                            "@media (max-width:600px)": {
                                padding: '25px 8px',
                            },
                        }}
                    >
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '17px',
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#0e182b',
                            marginBottom: '22px',
                        }}>
                            Your Complaints
                        </Typography>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '15px',
                            border: '1px solid #f2f2f2',
                            backgroundColor: '#fff',
                            marginBottom: '30px',
                        }}>
                            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '10px' }}>
                                <Grid item>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 16,
                                        fontWeight: '500',
                                        textAlign: 'left',
                                        color: '#0e182b',
                                    }}>CP001</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 12,
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        color: '#7d6900',
                                        padding: '3px 6px',
                                        borderRadius: '6px',
                                        backgroundColor: '#fef9c2',
                                        display: 'inline-block',
                                    }}>In Process</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 16,
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#0e182b'
                                    }}>
                                        Bus Delay Issue
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        letterSpacing: '0.26px',
                                        textAlign: 'left',
                                        color: '#717182',
                                    }}>
                                        Bus was delayed by 2 hours without prior notice
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        letterSpacing: '0.26px',
                                        textAlign: 'left',
                                        color: '#717182',
                                    }}>
                                        Operator • 2025-01-20
                                    </Typography>
                                </Grid>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        color: '#717182',
                                        padding: '10px',
                                        backgroundColor: '#eff6ff',
                                    }}>
                                        <strong>Resolution: </strong> We are investigating with the operator. Will update
                                        within 24 hours.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '15px',
                            border: '1px solid #f2f2f2',
                            backgroundColor: '#fff',
                        }}>
                            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '10px' }}>
                                <Grid item>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 16,
                                        fontWeight: '500',
                                        textAlign: 'left',
                                        color: '#0e182b',
                                    }}>CP002</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 12,
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        color: '#208b3d',
                                        padding: '3px 6px',
                                        borderRadius: '6px',
                                        backgroundColor: '#c5ffd5',
                                        display: 'inline-block',
                                    }}>In Process</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 16,
                                        fontWeight: 600,
                                        textAlign: 'left',
                                        color: '#0e182b'
                                    }}>
                                        Bus Delay Issue
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        letterSpacing: '0.26px',
                                        textAlign: 'left',
                                        color: '#717182',
                                    }}>
                                        Bus was delayed by 2 hours without prior notice
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        letterSpacing: '0.26px',
                                        textAlign: 'left',
                                        color: '#717182',
                                    }}>
                                        Operator • 2025-01-20
                                    </Typography>
                                </Grid>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: 13,
                                        fontWeight: 400,
                                        textAlign: 'left',
                                        color: '#717182',
                                        padding: '10px',
                                        backgroundColor: '#eff6ff',
                                    }}>
                                        <strong>Resolution: </strong> We are investigating with the operator. Will update
                                        within 24 hours.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid >
        </>
    )
}
export default Complaints